import { from, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { dfimAxios } from '../config/Axios';
import {
  GET_COMPANIES,
  COMPANY_CREATE,
  COMPANY_EDIT,
  COMPANY_DELETE,
  getAllCompaniesSuccess,
  getAllCompaniesError,
  companyCreateSuccess,
  companyCreateError,
  companyEditSuccess,
  companyEditError,
  companyDeleteSuccess,
  companyDeleteError,
} from '../actions/Company';

const companiesGetRequest = () =>
  dfimAxios.get('/api/company/all').then((response) => response.data);
const getUserCompanyPromise = (user) =>
  new Promise((resolve, reject) => {
    if (!user) {
      reject(Error('Could not get companies. User not found'));
    }

    const resultSuccess = {
      result: {
        companies: [user.company],
      },
      status: {
        code: '309',
        message: 'Companies fetched',
      },
    };
    resolve(resultSuccess);
  });

const companyCreateRequest = (input) =>
  dfimAxios
    .post('/api/company/create', input, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
const companyEditRequest = (input) =>
  dfimAxios
    .put('/api/company/edit', input, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
const companyDeleteRequest = (input) =>
  dfimAxios
    .delete('/api/company/delete', {
      headers: {
        'Content-Type': 'application/json',
      },
      data: { id: input },
    })
    .then((response) => response.data);

export const CompaniesGetAllEpic = (action$) =>
  action$.pipe(
    ofType(GET_COMPANIES),
    switchMap((action) =>
      from(
        action.payload.result.user.authority === 'ADMIN'
          ? companiesGetRequest()
          : getUserCompanyPromise(action.payload.result.user)
      ).pipe(
        map((data) => getAllCompaniesSuccess(data)),
        catchError((error) => of(getAllCompaniesError(error)))
      )
    )
  );

export const companyCreateEpic = (action$) =>
  action$.pipe(
    ofType(COMPANY_CREATE),
    switchMap((action) =>
      from(companyCreateRequest(action.payload)).pipe(
        map((data) => companyCreateSuccess(data)),
        catchError((error) => of(companyCreateError(error)))
      )
    )
  );

export const companyEditEpic = (action$) =>
  action$.pipe(
    ofType(COMPANY_EDIT),
    switchMap((action) =>
      from(companyEditRequest(action.payload)).pipe(
        map((data) => companyEditSuccess(data)),
        catchError((error) => of(companyEditError(error)))
      )
    )
  );

export const companyDeleteEpic = (action$) =>
  action$.pipe(
    ofType(COMPANY_DELETE),
    switchMap((action) =>
      from(companyDeleteRequest(action.payload)).pipe(
        map((data) => companyDeleteSuccess(data)),
        catchError((error) => of(companyDeleteError(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [CompaniesGetAllEpic, companyCreateEpic, companyEditEpic, companyDeleteEpic];
